export default __webpack_public_path__ + "static/media/u2-ubahn-neubauprojekte-wien.c464b866.svg";